import { AgentsFilters, IUserType } from "../../agents.model";

export const buildStringListOptions = (items: string[] | null | undefined) =>
    (items ?? [])
        .filter(Boolean)
        .map((item) => ({
            label: item,
            value: item,
        }));

export const buildUserTypeOptions = (userTypes: IUserType[] | null | undefined) =>
    (userTypes ?? []).map((userType) => ({
        label: userType.userType,
        value: userType.userType,
    }));

export const countActiveAgentFilters = (filters: AgentsFilters): number =>
    Object.values(filters).reduce(
        (count, value) => (value.length > 0 ? count + 1 : count),
        0
    );
